<script>
import topMenu from '@/components/brand/components/topMenu';
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('brand/info')
export default {
  name: "BrandContent",
  components: {
    topMenu
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: 0,
    }
  },
  methods: {
    ...mapActions([
      'GET_STATISTIC',
    ]),
  },
  computed: {
    ...mapGetters([
      'BRAND_STATISTIC',
      'IS_BRAND_STATISTIC',
    ]),
    mainBlock() {
      return this.BRAND_STATISTIC.main
    },
    photosAndDocuments() {
      return this.BRAND_STATISTIC.photosAndDocuments
    },
    onlineSales() {
      return this.BRAND_STATISTIC.onlineSales
    },
    productPublication() {
      return this.BRAND_STATISTIC.productPublication
    },
    relationshipStatus() {
      return this.BRAND_STATISTIC.relationshipStatus
    },
    availability() {
      return this.BRAND_STATISTIC.availability
    },
    warehousePosition() {
      return this.BRAND_STATISTIC.warehousePosition
    },
    languages() {
      return this.BRAND_STATISTIC.languages
    }
  },
  created() {
    if (this.IS_BRAND_STATISTIC !== this.brandId) {
      this.GET_STATISTIC({id: this.brandId, th: this});
      this.$store.commit('brand/info/IS_FULL_STATISTIC', this.brandId);
    }
  }
}
</script>

<template>
  <div>
    <top-menu v-bind:sale-id="brandId"></top-menu>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="lg">
      <b-container fluid class="mb-3">
        <b-row class="mb-5">
          <b-col>
            <b-card no-body>
              <b-card-header><h3>Верхний блок</h3></b-card-header>
              <b-card-body class="py-2 px-3">
                <b-row class="mb-3">
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Основное</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in mainBlock" :key="index" :data-type="index">
                            <td :class="{'text-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Фото и документы</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in photosAndDocuments" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Онлайн-продажи</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in onlineSales" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Публикация товаров</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in productPublication" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Статус родства</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in relationshipStatus" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Наличие</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in availability" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>
                              <template v-if="index === 'warehouseCost'">
                                {{ block.value }}
                              </template>
                              <template v-else>
                                {{ nFormat(block.value) }}
                              </template>
                            </td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-card>
                      <b-card-header><strong>Складская позиция</strong></b-card-header>
                      <b-card-body>
                        <table class="table table-hover table-striped">
                          <tbody>
                          <tr v-for="(block, index) in warehousePosition" :key="index" :data-type="index">
                            <td :class="{'font-weight-bold': block.isBold}">{{ block.title }}</td>
                            <td>{{ nFormat(block.value) }}</td>
                            <td>{{ block.ratio }} <span v-if="block.ratio">%</span> </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card no-body>
              <b-card-header><h3>Нижний блок</h3></b-card-header>
              <b-card-body>
                <b-row>
                  <b-col>
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Язык</th>
                          <th>Тип товара</th>
                          <th></th>
                          <th>Краткое описание</th>
                          <th></th>
                          <th>Полное описание</th>
                          <th></th>
                          <th>Характеристики</th>
                          <th></th>
                          <th>Рандомное описание</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(lang, index) in languages" :key="index">
                          <td>{{index.toUpperCase()}}</td>
                          <td>{{lang.productType.value}}</td>
                          <td>{{lang.productType.ratio}}</td>
                          <td>{{lang.shortDescription.value}}</td>
                          <td>{{lang.shortDescription.ratio}}</td>
                          <td>{{lang.fullDescription.value}}</td>
                          <td>{{lang.fullDescription.ratio}}</td>
                          <td>{{lang.characteristics.value}}</td>
                          <td>{{lang.characteristics.ratio}}</td>
                          <td>{{lang.randomDescription.value}}</td>
                          <td>{{lang.randomDescription.ratio}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<style scoped>

</style>